import { analyticsTheme } from "../analyticsTheme";

export type MetricColors = {
  success: string;
  warning: string;
  error: string;
  default: string;
};

export type MetricLevel = keyof MetricColors;

export const metricColors: MetricColors = {
  success: analyticsTheme.metricSuccess,
  warning: analyticsTheme.metricOrange,
  error: analyticsTheme.metricError,
  default: analyticsTheme.metricDefault,
};

export const getMetricLevel = (
  metric?: number,
  target?: number,
  aim: "high" | "low" = "high"
): MetricLevel => {
  if (metric === undefined || target === undefined) return "default";
  if (aim === "low") {
    if (metric <= target) return "success";
    if (metric <= target / 0.55) return "warning";
    return "error";
  }
  if (metric >= target) return "success";
  if (metric >= target * 0.55) return "warning";
  return "error";
};

export const getMetricColor = (
  metric?: number,
  target?: number,
  colors: MetricColors = metricColors,
  aim: "high" | "low" = "high"
): string => colors[getMetricLevel(metric, target, aim)];
